import { useState, useEffect } from "react";

const navLinks = [
  { label: "Home", href: "#home" },
  { label: "Gallery", href: "#gallery" },
  { label: "Services", href: "#services" },
  { label: "About", href: "#about" },
  { label: "Booking", href: "#booking" },
  { label: "Contact", href: "#contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleNavClick = (href: string) => {
    setMenuOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? "bg-white/95 backdrop-blur-sm border-b border-[#E8E4DF]" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 flex items-center justify-between h-16 lg:h-20">
        {/* Logo */}
        <a
          href="#home"
          onClick={(e) => { e.preventDefault(); handleNavClick("#home"); }}
          className="flex items-center gap-3 cursor-pointer"
        >
          <img
            src="https://public.readdy.ai/ai/img_res/a99c583f-c7d6-4743-b56e-d3f6a869d545.png"
            alt="Atelier NANA ロゴ"
            className="h-10 w-10 object-contain rounded-full"
          />
          <span
            className="font-['Cormorant_Garamond'] text-xl font-semibold tracking-widest text-[#1A1A1A]"
          >
            Atelier NANA
          </span>
        </a>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              onClick={(e) => { e.preventDefault(); handleNavClick(link.href); }}
              className="font-['DM_Sans'] text-sm font-medium text-[#3A3A3A] hover:text-[#C9A87C] transition-colors duration-300 tracking-wider cursor-pointer whitespace-nowrap"
            >
              {link.label}
            </a>
          ))}
        </nav>

        {/* CTA Button */}
        <a
          href="#booking"
          onClick={(e) => { e.preventDefault(); handleNavClick("#booking"); }}
          className="hidden md:flex items-center gap-2 bg-[#3D2E2A] text-white text-sm font-medium px-6 py-2.5 rounded-full hover:bg-[#C9A87C] transition-colors duration-300 cursor-pointer whitespace-nowrap font-['DM_Sans'] tracking-wider"
        >
          <i className="ri-calendar-line text-sm"></i>
          ご予約
        </a>

        {/* Hamburger */}
        <button
          className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="メニュー"
        >
          <i className={`text-xl text-[#1A1A1A] ${menuOpen ? "ri-close-line" : "ri-menu-line"}`}></i>
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-white/98 backdrop-blur-sm border-b border-[#E8E4DF] px-6 pb-6">
          <nav className="flex flex-col gap-4 pt-4">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={(e) => { e.preventDefault(); handleNavClick(link.href); }}
                className="font-['DM_Sans'] text-sm font-medium text-[#3A3A3A] hover:text-[#C9A87C] transition-colors py-2 border-b border-[#F0EDE9] cursor-pointer"
              >
                {link.label}
              </a>
            ))}
            <a
              href="#booking"
              onClick={(e) => { e.preventDefault(); handleNavClick("#booking"); }}
              className="mt-2 flex items-center justify-center gap-2 bg-[#3D2E2A] text-white text-sm font-medium px-6 py-3 rounded-full cursor-pointer whitespace-nowrap"
            >
              <i className="ri-calendar-line"></i>
              ご予約
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}
